<template>
  <div>
    <section-definition :title="page.title"></section-definition>
    <v-container fluid>

      <view-coachup
          :coachup="coachup"
          v-if="coachup"
          :show-x="false"
      ></view-coachup>

      <v-layout wrap v-else>
        <v-flex grow></v-flex>
        <v-flex shrink> Sorry, the requested coach up couldn't be found.  Please contact the help if this issue continues</v-flex>
        <v-flex grow></v-flex>
      </v-layout>

    </v-container>
  </div>
</template>





<script>

   import viewCoachup from '../components/viewCoachup';
   import data_getters from '../mixins/data_getters'


   export default {
      name: 'ViewCoachUpContainer',
      components:{
         viewCoachup
      },
      mixins: [data_getters],
      data() {
         return {
            coachup: null,

            page: {
               title: "View Coach Up Details",
            },
         };
      },
      async created(){

         this.coachup  = await this.get_coachups({_id: this.$route.params.coachup_id});
         console.log(this.coachup)
         // this.coachup = tmp[0];

      }
   };
</script>
